import { render } from "./OrdersImportPage.vue?vue&type=template&id=7e45255e&scoped=true&ts=true"
import script from "./OrdersImportPage.ts?vue&type=script&lang=ts"
export * from "./OrdersImportPage.ts?vue&type=script&lang=ts"

import "./OrdersImportPage.vue?vue&type=style&index=0&id=7e45255e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e45255e"]])

export default __exports__